import React, { Component, PropTypes } from 'react';
import { ParameterType } from 'types';
import CheckboxControl from 'components/CheckboxControl';
import TipControl from 'components/TipControl';
import SelectControl from 'components/SelectControl';
import { arrayContainsValue } from 'core/utils.js';

import ActionCreators from 'actions/ActionCreators';

const DEFAULT_TAX_OPTION = 18;
const TAX_OPTIONS_IDS = [3, 4, 18];

class PaymentPane extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired,
        taxOption: PropTypes.number
    };

    static defaultProps = {
        taxOption: DEFAULT_TAX_OPTION
    };

    state = {
        taxActive: false,
        taxOption: DEFAULT_TAX_OPTION,
        paymentMethods: new Set()
    };

    componentWillMount() {
        const paymentMethods = new Set();
        const payment_methods = this.props.parameters.payment_methods.value || [];

        [1, 5, 17].forEach((value) => {
            if (payment_methods.indexOf(value) !== -1) {
                paymentMethods.add(value);
            }
        });

        var { taxOption } = this.state;
        var taxActive = false;
        TAX_OPTIONS_IDS.some((value) => {
            if (payment_methods.indexOf(value) !== -1) {
                taxActive = true;
                taxOption = value;
                paymentMethods.add(value);
                return true;
            }
        });

        this.setState({ paymentMethods, taxOption, taxActive });
    }

    _onTaxModeChange = (event, value) => {
        var taxActive = value;
        var { taxOption, paymentMethods } = this.state;
        if (value) {
            paymentMethods.add(taxOption);
        } else {
            paymentMethods.delete(taxOption);
        }

        this.setState({
            taxActive,
            paymentMethods,
            taxOption
        });

        this._updateParameter();
    };

    _onTaxOptionChange = (event, value) => {
        var oldValue = this.state.taxOption;
        var {paymentMethods} = this.state;
        paymentMethods.add(value[0]);
        paymentMethods.delete(oldValue);
        this.setState({
            taxOption: value[0],
            paymentMethods
        });
        this._updateParameter();
    };

    _onChange = (event, value) => {
        var {paymentMethods} = this.state;
        const name = parseInt(event.target.name);
        if (value) {
            paymentMethods.add(name);
        } else {
            paymentMethods.delete(name);
        }
        this.setState({ paymentMethods });
        this._updateParameter();
    };

    _updateParameter = () => {
        var {paymentMethods} = this.state;
        paymentMethods = paymentMethods.toJSON();
        if (paymentMethods.length === 0) {
            paymentMethods = undefined;
        }
        ActionCreators.updateParameter({
            'payment_methods': paymentMethods
        });
    };

    render() {
        const { paymentMethods } = this.state;

        var parameters = this.props.parameters.payment_methods.values;

        var taxOptions = [];
        for (let i = 0; i < TAX_OPTIONS_IDS.length; i++) {
            taxOptions[i] = {
                value: TAX_OPTIONS_IDS[i],
                label: parameters[TAX_OPTIONS_IDS[i]].value
            };
        }

        return (
            <div className="AdditionalParametersPane-payments">
                <div className="AdditionalParametersPane-field">
                    <CheckboxControl
                        label={parameters[1].value}
                        name={1}
                        onChange={this._onChange}
                        value={paymentMethods.has(1)} />
                    <TipControl
                        className="ParametersScreen-helpBox"
                        label={parameters[1].tip} />
                </div>
                <div className="AdditionalParametersPane-field">
                    <CheckboxControl
                        label={parameters[2].value}
                        name={2}
                        onChange={this._onTaxModeChange}
                        value={this.state.taxActive} />
                    <SelectControl
                        className="AdditionalParametersPane-tax"
                        options={taxOptions}
                        value={this.state.taxOption}
                        disabled={!this.state.taxActive}
                        onChange={this._onTaxOptionChange} />
                    <TipControl
                        className="ParametersScreen-helpBox"
                        label={parameters[2].tip} />
                </div>
                <div className="AdditionalParametersPane-field">
                    <CheckboxControl
                        label={parameters[5].value}
                        name={5}
                        onChange={this._onChange}
                        value={paymentMethods.has(5)}/>
                    <TipControl label={parameters[5].tip} />
                </div>
                <div className="AdditionalParametersPane-field">
                    <CheckboxControl
                        label={parameters[17].value}
                        name={17}
                        onChange={this._onChange}
                        value={paymentMethods.has(17)} />
                    <TipControl label={parameters[17].tip} />
                </div>
            </div>
        )
    }

}

export default PaymentPane;



// WEBPACK FOOTER //
// ./client/components/ParametersScreen/PaymentPane.js